import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  FETCH_VENDOR_DASHBOARD_DATA_REQUEST,
  FETCH_VENDOR_DASHBOARD_DATA_SUCCESS,
  FETCH_VENDOR_DASHBOARD_DATA_FAILURE,
  FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST,
  FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS,
  FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE,
} from "./DashboardType";

const initialState = {
  loading: false,
  data: null,
  error: null,
  vendorData: null,
  customerData: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        vendorData: null,
        customerData: null,
        error: null,
      };
    case FETCH_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        vendorData: null,
        customerData: null,
      };
    case FETCH_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: null,
        vendorData: null,
        customerData: null,
      };
    case FETCH_VENDOR_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        vendorData: null,
        customerData: null,
        error: null,
      };
    case FETCH_VENDOR_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: null,
        customerData: null,
        vendorData: action.payload,
      };
    case FETCH_VENDOR_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        vendorData: null,
        customerData: null,
        error: action.payload,
      };

    case FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        vendorData: null,
        customerData: null,
        error: null,
      };
    case FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: null,
        vendorData: null,
        customerData: action.payload,
      };
    case FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        vendorData: null,
        customerData: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
